import { render, staticRenderFns } from "./AnnouncementBell.vue?vue&type=template&id=f055e786"
import script from "./AnnouncementBell.vue?vue&type=script&lang=js"
export * from "./AnnouncementBell.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBell.vue?vue&type=style&index=0&id=f055e786&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports